const colors = {
  // offwhite
  offwhite: '#f5f5f5',
  // green
  olivegreen: '#556B2F',
  greencheckbox: '#72C600',

  // reds
  redDark1: '#cf4435',
  redDark2: '#b83c30',
  redLight1: '#eb6f63',
  redLight2: '#f0938a',
  redLight3: '#f5b7b1',
  redLight4: '#fadbd8',
  red: '#e74c3c',

  // other reds
  errorMsg: '#bf0711',
  errorMsg1: '#e22e1c',

  // dark oranges
  darkOrangeDark1: '#e26112',
  darkOrangeDark2: '#d04f00',
  darkOrangeLight1: '#f6965b',
  darkOrangeLight2: '#f8b084',
  darkOrangeLight3: '#fbcbad',
  darkOrangeLight4: '#fce4d6',
  darkOrange: '#f47c32',

  // oranges
  orangeLight5: '#f4d555',
  orangeLight4: '#fdedd6',
  orangeLight3: '#fbdcad',
  orangeLight2: '#f8ca84',
  orangeLight1: '#f6b95b',
  orange: '#f4a732',
  orangeDark1: '#e58c05',
  orangeDark2: '#d07d00',

  // yellows
  yellowDark1: '#e6be19',
  yellowDark2: '#d5ab00',
  yellowLight1: '#f6dd78',
  yellowLight2: '#f8e69a',
  yellowLight3: '#fbeebb',
  yellowLight4: '#fdf7dd',
  yellowLight5: '#fffde6',
  yellowLight6: '#fef9e6',
  yellow: '#f4d556',

  // S37 greens
  science37Dark1: '#6bb408',
  science37Dark2: '#5b9e00',
  science37Dark3: '#007541',
  science37Light1: '#8ed133',
  science37Light2: '#ad6',
  science37Light3: '#c7e899',
  science37Light4: '#e3f4cc',
  science37Light5: '#FBFFF7',
  science37: '#72c600',
  science37Variant1: '#58c323',

  // science greeens
  scienceGreenDark1: '#034322',
  scienceGreenDark2: '#03351b',
  scienceGreenLight1: '#337d56',
  scienceGreenLight2: '#669d80',
  scienceGreenLight3: '#99beab',
  scienceGreenLight4: '#ccded5',
  scienceGreen: '#005c2c',

  // extra greens
  green1: '#7ed321',

  // ocean blues
  oceanDark1: '#5eb7a7',
  oceanDark2: '#54a496',
  oceanLight1: '#90cfc4',
  oceanLight2: '#acdbd3',
  oceanLight3: '#c7e7e1',
  oceanLight4: '#e3f3f0',
  ocean: '#74c3b5',

  // blues
  blueDark1: '#256f7f',
  blueDark2: '#235f6c',
  blueDark3: '#212b36',
  blueLight1: '#6095a1',
  blueLight2: '#88afb8',
  blueLight3: '#afcad0',
  blueLight4: '#d7e4e7',
  blue: '#387a89',

  // sky blues
  skyDark1: '#216bad',
  skyDark2: '#1a578d',
  skyLight1: '#6096c6',
  skyLight2: '#88b0d4',
  skyLight3: '#afcbe3',
  skyLight4: '#d7e5f1',
  sky: '#387cb8',

  // light blues
  lightBlueDark1: '#71b2d5',
  lightBlueDark2: '#5c9ec1',
  lightBlueLight1: '#a1d1ea',
  lightBlueLight2: '#b8dcef',
  lightBlueLight3: '#d0e8f5',
  lightBlueLight4: '#e7f3fa',
  lightBlue: '#89c5e5',

  // grays
  grayDark1: '#a4c3c2',
  grayDark2: '#8aadab',
  grayDark3: '#9b9b9b',
  grayDark4: '#a3a3a3',
  grayDark5: '#7a7a7a',
  grayDark6: '#4a4a4a',
  grayDark7: '#363636',
  grayDark8: '#b4b4b4',
  grayDark9: '#dfdfdf',
  grayDark10: '#334750',
  grayDark11: '#bbb',
  grayLight1: '#c5d8d7',
  grayLight2: '#d4e2e1',
  grayLight3: '#e2ebeb',
  grayLight4: '#f1f5f5',
  grayLight5: '#ebebeb',
  grayLight6: '#faf6f5',
  grayLight7: '#f4f4f4',
  grayLight8: '#dbdbdb',
  grayLight9: '#e2e2e2',
  gray: '#b7cecd',
  grayDark: '#A1A1A1',

  // extra grays
  blueGray: '#637381',
  darkBlueGray: '#334750',
  blueFacebook: '#3b5998',
  blueTwitter: '#1DA1F2',
  blueLinkedIn: '#0e76a8',
  commonGray2: '#d8d8d8',
  commonGray1: '#ccc',
  darkGray: '#919eab',
  lightGray: '#f8f9f9',
  mediumGray: '#dfe3e8',

  // purples
  purpleDark1: '#4a5085',
  purpleDark2: '#3a3f6e',
  purpleLight1: '#797eaf',
  purpleLight2: '#9a9ec3',
  purpleLight3: '#bcbfd7',
  purpleLight4: '#dddfeb',
  purple: '#575e9b',

  // neutrals
  neutral0: '#fff',
  neutral10: '#e4e6e8',
  neutral15: '#d7dadc',
  neutral20: '#caced0',
  neutral25: '#bcc2c5',
  neutral30: '#aeb5b8',
  neutral35: '#a2a9ad',
  neutral40: '#949da1',
  neutral45: '#879195',
  neutral5: '#f1f3f3',
  neutral50: '#798489',
  neutral55: '#6c777e',
  neutral60: '#5f6b72',
  neutral65: '#526066',
  neutral70: '#44535b',
  neutral75: '#344750',
  neutral80: '#29353b',
  neutral85: '#1c2427',
  neutral90: '#061015',
  neutral95: '#3d3f4f',

  // blacks
  black1: '#333',

  // transparent
  transparent: 'transparent',

  // yellow
  yellow1: '#f4d555',
  yellow2: '#fef9e6',

  // alphas
  alpha13: 'rgba(9, 30, 66, 0.13)',
  alpha2: 'rgba(19, 23, 27, 0.02)',
  alpha25: 'rgba(9, 30, 66, 0.25)',
  alpha31: 'rgba(9, 30, 66, 0.31)',
  alpha36: 'rgba(9, 30, 66, 0.36)',
  alpha4: 'rgba(9, 30, 66, 0.04)',
  alpha42: 'rgba(9, 30, 66, 0.42)',
  alpha48: 'rgba(9, 30, 66, 0.48)',
  alpha54: 'rgba(6, 16, 21, 0.54)',
  alpha60: 'rgba(6, 16, 21, 0.6)',
  alpha66: 'rgba(6, 16, 21, 0.66)',
  alpha71: 'rgba(6, 16, 21, 0.71)',
  alpha77: 'rgba(6, 16, 21, 0.77)',
  alpha8: 'rgba(9, 30, 66, 0.08)',
  alpha82: 'rgba(9, 30, 66, 0.31)',
  alpha89: 'rgba(6, 16, 21, 0.89)',
  alpha95: 'rgba(6, 16, 21, 0.95)',
};

export default colors;
